import { Download, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePWAInstall } from '@/hooks/usePWAInstall';
import { Link } from 'react-router-dom';

interface InstallButtonProps {
  variant?: 'default' | 'compact' | 'icon';
  className?: string;
}

export function InstallButton({ variant = 'default', className }: InstallButtonProps) {
  const { isInstallable, isInstalled, isIOS, isStandalone, promptInstall } = usePWAInstall();

  // Don't show if already installed or running in standalone mode
  if (isInstalled || isStandalone) return null;

  // For iOS, show link to install page
  if (isIOS) {
    if (variant === 'icon') {
      return (
        <Link to="/install">
          <Button variant="ghost" size="icon" className={className} title="Install App">
            <Smartphone className="h-5 w-5" />
          </Button>
        </Link>
      );
    }

    if (variant === 'compact') {
      return (
        <Link to="/install">
          <Button variant="outline" size="sm" className={className}>
            <Smartphone className="mr-2 h-4 w-4" />
            Install
          </Button>
        </Link>
      );
    }

    return (
      <Link to="/install">
        <Button variant="outline" className={className}>
          <Smartphone className="mr-2 h-4 w-4" />
          Install App
        </Button>
      </Link>
    );
  }

  // For other browsers with install prompt support
  if (!isInstallable) return null;

  const handleInstall = async () => {
    await promptInstall();
  };

  if (variant === 'icon') {
    return (
      <Button 
        variant="ghost" 
        size="icon" 
        className={className} 
        onClick={handleInstall}
        title="Install App"
      >
        <Download className="h-5 w-5" />
      </Button>
    );
  }

  if (variant === 'compact') {
    return (
      <Button variant="outline" size="sm" className={className} onClick={handleInstall}>
        <Download className="mr-2 h-4 w-4" />
        Install
      </Button>
    );
  }

  return (
    <Button variant="outline" className={className} onClick={handleInstall}>
      <Download className="mr-2 h-4 w-4" />
      Install App
    </Button>
  );
}
